import { render, staticRenderFns } from "./webText.vue?vue&type=template&id=00d451b6&style=%0A%20%20%20%20background%3A%20linear-gradient(%0A%20%20%20%20%20%20rgba(209%2C%20249%2C%20248%2C%200.5)%2C%0A%20%20%20%20%20%20rgba(196%2C%20210%2C%20249%2C%200.5)%0A%20%20%20%20)%3B%0A%20%20&"
import script from "./webText.vue?vue&type=script&lang=js&"
export * from "./webText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VCardTitle,VTab,VTabItem,VTabs,VTabsItems})
